/* eslint-disable max-len */
import 'react';

const EditSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h12v12H0z" />
            <g stroke="currentColor" strokeLinecap="round" strokeWidth="1.25">
                <path d="M11 6.875v2.292C11 10.179 10.18 11 9.167 11H2.833A1.833 1.833 0 011 9.167V2.833C1 1.821 1.82 1 2.833 1h2.209M5.428 7.5l5.19-6.088" />
            </g>
        </g>
    </svg>
);
export default EditSvg;
